// Generic cooking ingredients: foraged goods, dungeon drops, and pantry staples.
// Stored under state.inventory.ingredients. Crops are handled separately in save.js.

import { getState, save } from './save.js';

export function getIngredients(){ return getState().inventory.ingredients || {}; }

export function getIngredient(id){ return getIngredients()[id] || 0; }

export function addIngredient(id, n = 1){
  const inv = getState().inventory;
  inv.ingredients = inv.ingredients || {};
  inv.ingredients[id] = (inv.ingredients[id] || 0) + n;
  save();
  return inv.ingredients[id];
}

export function spendIngredient(id, n = 1){
  const inv = getState().inventory;
  inv.ingredients = inv.ingredients || {};
  if ((inv.ingredients[id] || 0) < n) return false;
  inv.ingredients[id] -= n;
  save();
  return true;
}

// Readable names for the kitchen UI.
export const INGREDIENT_NAMES = {
  'berry': 'Wild Berry',
  'mushroom': 'Forest Mushroom',
  'herb': 'Fresh Herb',
  'honey': 'Honey Jar',
  'bone-meal': 'Bone Meal',
  'patty': 'Ground Patty',
  'bbq-sauce': 'Bread Boi BBQ Sauce',
  // ---- lunar goods (from the moon's cheese shop + craters) ----
  'moon_cheese': 'Moon Cheese',
  'moon_egg': 'Moon Egg',
  'moon_milk': 'Moon Milk',
  'stardust': 'Stardust',
  'comet_sugar': 'Comet Sugar',
  'space_bun': 'Space Bun',
  'nebula_lettuce': 'Nebula Lettuce'
};

export function ingredientName(id){ return INGREDIENT_NAMES[id] || id; }
